module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Asian Miracle Cosmetics","short_name":"Asian Miracle","description":"Botanical skincare and haircare: Miracle Grow Day and Night Cream plus Miracle Hair Oil.","start_url":"/","background_color":"#f2f5ee","theme_color":"#1e3d2f","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"83bca9187a12d07842928f5804a9e588"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
